import { queryOptions } from "@tanstack/react-query";
import {
  getExerciseHistory,
  searchExerciseHistory,
  type Api,
} from "api-client";
import { assert } from "utils";

import { type StatisticsRepository } from "./StatisticsRepository";
export function createPrivateStatisticsRepository(): StatisticsRepository {
  return {
    queryKey: ["statistics", "private"],
    async searchPage(input) {
      return (await searchExerciseHistory({ query: input })).data.data;
    },
    historyOptions({ exerciseId, ...query }) {
      return queryOptions<Api.GetExerciseHistory.Output.Self>({
        queryKey: ["statistics", "private", "history", exerciseId, query],
        async queryFn() {
          assert(exerciseId, "Exercise ID required");
          return (await getExerciseHistory({ path: { exerciseId }, query }))
            .data.data;
        },
      });
    },
  };
}
